import atividadesTips from "./atividades.tips";

export default {
    retornarDica(value){
        return [
            ...atividadesTips,
        ].find(tip => tip.value === value);
    },

    atividadesTips,
}